
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class OrderProductPlanDiscontinuationModel extends Model<OrderProductPlanDiscontinuationModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'orderId', type: 'string' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'adjustmentAmount', type: 'number' },
		{ name: 'remainingAmount', type: 'number' },
		{ name: 'order', type: 'OrderModel', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'productPlan', type: 'ProductPlanModel', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'changeLogPrimaryRelationEntityId', type: 'string' },
		{ name: 'changeLogPrimaryRelationEntityType', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public productPlanId?: string;
	public adjustmentAmount: number;
	public remainingAmount: number;
	public order?: OrderModel;
	public productPlan?: ProductPlanModel;
	public changeLogPrimaryRelationEntityId: string;
	public changeLogPrimaryRelationEntityType: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.productPlanId = undefined;
		this.adjustmentAmount = 0;
		this.remainingAmount = 0;
		this.order = undefined;
		this.productPlan = undefined;
		this.changeLogPrimaryRelationEntityId = '';
		this.changeLogPrimaryRelationEntityType = '';
		
	}
	getProperties(){
		return OrderProductPlanDiscontinuationModel.classProperties;
	}
}

